export default __webpack_public_path__ + "static/slider-2-b1db8ce105a9bc3d143323a406fc3f89.jpg";